export default __webpack_public_path__ + "static/media/zambia1.355a69ba.jpg";